<div class="container side-panel" bind:this={sidePanelElement}>
  <slot />
</div>


<script>
import store from "../../state";
import { onMount, createEventDispatcher } from "svelte/internal";
const dispatch = createEventDispatcher();
// html vars
let shouldActivateComponent = false;
let sidePanelElement;
store.subscribe(state => {
    // shouldActivateComponent =
    //   state.currentState.includes(
    //     `${STATES_MAIN.START}.${STATES_START.SEARCHING}`
    //   ) || state.searchResults.length > 0;
});
onMount(() => {
    dispatch("mount", sidePanelElement);
});
</script>


<style>.side-panel{flex:0 0 24rem;background:#fff;max-width:24rem;padding:1.625rem 2.1875rem 0;height:100%;display:flex;flex-direction:column;position:relative;overflow-y:auto}.side-panel>:last-child{padding-bottom:1.625rem}@media screen and (max-width:767px){.side-panel{max-width:100%}}</style>
